import React from 'react';
import { Swiper, SwiperSlide } from 'swiper/react';
import { Autoplay, Navigation } from 'swiper/modules';
import { Link } from 'react-router-dom';
import { useAuth, HideWhenAuthenticated } from '../../../context/AuthContext';
import 'swiper/css';
import 'swiper/css/autoplay';
import 'swiper/css/navigation';

const BannerCarousel = () => {
    const { isAuthenticated } = useAuth(); // Récupérez l'état d'authentification

    const banners = [
        {
            id: 1,
            backgroundClass: "hero6-bg-thumb1",
            title: "Trouvez l'aide ménagère idéale",
            description: "Driven Home Services connecte les clients avec des aides ménagères qualifiées et vérifiées pour un service fiable et professionnel.",
            buttonText: "Créer un profil",
            buttonLink: "/register",
        },
        {
            id: 2,
            backgroundClass: "hero6-bg-thumb2",
            title: "Soumettez votre profil",
            description: "Aides ménagères, rejoignez notre plateforme pour trouver des emplois correspondant à vos compétences et disponibilités.",
            buttonText: "Créer un profil",
            buttonLink: "/register",
        },
        {
            id: 3,
            backgroundClass: "hero6-bg-thumb3",
            title: "Gestion simplifiée des contrats",
            description: "Notre plateforme sécurisée facilite la création, la signature et le suivi des contrats entre clients et aides ménagères.",
            buttonText: "Découvrir nos services",
            buttonLink: "/aide-domicile",
        },
        {
            id: 4,
            backgroundClass: "hero6-bg-thumb4",
            title: "Sécurité et confiance garanties",
            description: "Tous nos profils sont vérifiés par notre équipe et les interactions sont encadrées pour votre tranquillité d'esprit.",
            buttonText: "Rechercher un professionnel",
            buttonLink: "/professionals",
        },
    ];

    return (
        <section className="hero-section position-relative cus-z1 hero-style6">
            <Swiper
                loop={true}
                autoplay={{
                    delay: 5000,
                    disableOnInteraction: false,
                }}
                navigation={{
                    prevEl: '.swiper-button-prevteam',
                    nextEl: '.swiper-button-nextteam',
                }}
                modules={[Autoplay, Navigation]}
                className="hero-wrapper3"
            >
                {banners.map((banner) => (
                    <SwiperSlide key={banner.id}>
                        <div className="hero-version-item position-relative">
                            <div className={`hero6-bg ${banner.backgroundClass} position-absolute top-0 start-0`}></div>
                            <div className="container">
                                <div className="hero-content6 text-center">
                                    <span className="title-head mb-lg-4 mb-3 n0-clr text-uppercase fs-six fw-normal d-flex align-items-center justify-content-center gap-4 text-nowrap">
                                        <span className="line"></span> Driven Home Services
                                    </span>
                                    <h2 style={{fontSize: '15', color: '#fff', fontWeight: 'bold'}} className="mb-lg-5 mb-4">{banner.title}</h2>
                                    <p className="n0-clr mb-xxl-8 mb-xl-7 mb-sm-6 mb-6 fw-normal">
                                        {banner.description}
                                    </p>
                                    <div className="pra-grp position-relative mb-lg-0 mb-4">
                                        {/* Option 1 : Condition simple avec && */}
                                        {!isAuthenticated && (
                                            <Link
                                                to={banner.buttonLink}
                                                style={{borderRadius:"7%", color: "white", fontWeight: 'bold', backgroundColor:'#1d8d36'}}
                                                className="dhs-btn overflow-hidden d-inline-flex align-items-center gap-2 text-capitalize s1-bg py-xxl-3 py-3 px-xxl-7 px-lg-5 px-4 fw-500"
                                            >
                                                {banner.buttonText}
                                                <span className="icons">
                                                    <i className="ph ph-arrow-up-right"></i>
                                                </span>
                                            </Link>
                                        )}

                                        {/* Option 2 : Utilisation du composant HideWhenAuthenticated */}
                                        {/*
                                        <HideWhenAuthenticated>
                                            <Link
                                                to={banner.buttonLink}
                                                style={{borderRadius:"7%", color: "white", fontWeight: 'bold', backgroundColor:'#1d8d36'}}
                                                className="dhs-btn overflow-hidden d-inline-flex align-items-center gap-2 text-capitalize s1-bg py-xxl-3 py-3 px-xxl-7 px-lg-5 px-4 fw-500"
                                            >
                                                {banner.buttonText}
                                                <span className="icons">
                                                    <i className="ph ph-arrow-up-right"></i>
                                                </span>
                                            </Link>
                                        </HideWhenAuthenticated>
                                        */}
                                    </div>
                                </div>
                            </div>
                        </div>
                    </SwiperSlide>
                ))}
            </Swiper>
            <div className="swiper-btn-maintains">
                <div className="arrow-area d-flex align-items-center justify-content-between gap-xxl-3 gap-2 position-relative cus-z1">
                    <button type="button" className="swiper-button-prevteam rounded-circle d-center">
                        <img src="assets/images/icon/cus-arrowl.png" alt="img" />
                    </button>
                    <button type="button" className="swiper-button-nextteam active rounded-circle d-center">
                        <img src="assets/images/icon/cus-arrowr.png" alt="img" />
                    </button>
                </div>
            </div>
        </section>
    );
};

export default BannerCarousel;